// extracted by mini-css-extract-plugin
module.exports = {"cont":"_93444fe79c--cont--1x21f","icon":"_93444fe79c--icon--2mFQe"};